import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { MessagingUserSettingOutput } from 'infrastructure/graphql/messaging/user/model/messaging-user-setting.output';

import { ApiMutation } from '../../../../common/model/api.mutation';

export type UserSettingProperty =
	| 'USER_DEFERRED_MESSAGES_EMAIL_SEND_ENABLED'
	| 'USER_CONNECTION_REMINDER_EMAIL_SEND_ENABLED'
	| 'USER_MODULE_UNFINISHED_EMAIL_SEND_ENABLED'
	| 'USER_WEEKLY_SUMMARY_EMAIL_SEND_ENABLED';

export interface UpdateMessagingUserSettingInput {
	readonly property: UserSettingProperty;
	readonly value: String;
}

export interface UpdateMessagingUserSettingsInput {
	readonly ownerId: string;
	readonly settings: UpdateMessagingUserSettingInput[];
}

export interface UpdateMessagingUserSettingsParams {
	input: UpdateMessagingUserSettingsInput;
}

@Injectable({ providedIn: 'root' })
export class UpdateMessagingUserSettingsApiMutation extends ApiMutation<
	MessagingUserSettingOutput[],
	UpdateMessagingUserSettingsParams
> {
	client = 'messaging';
	document = gql`
		mutation SaveUserSetting($input: SaveUserSettingInput!) {
			saveUserSetting(input: $input) {
				property
				userId
				value
				type
			}
		}
	`;
	method = 'saveUserSetting';
}
